import { useIntl } from 'react-intl';
import { PropTypes } from 'prop-types';
import { useLocation, useNavigate } from 'react-router-dom';
import AccionaButton from '../../../../components/AccionaButton';
import AccionaResult from '../../../../components/AccionaResult';

const ErrorPage = ({ errorMessages }) => {
  const intl = useIntl();
  const navigate = useNavigate();
  const pidstring = useLocation().search;
  const centerStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    marginTop: '25px',
  };
  const errorType = errorMessages.errorType;
  const status = errorMessages.status;

  return (
    <AccionaResult
      id="errorResult"
      icon={
        <i className="fas fa-times-circle fa-8x" style={{ color: '#ff0000' }} />
      }
      title={intl.formatMessage({
        id: errorType || 'Internal server error',
        defaultMessage: 'Internal server error',
      })}
      subTitle={`${status} - ${intl.formatMessage({ id: status || 500 })} `}
      extra={[
        <div className="form-row" key="errorNotice" style={centerStyle}>
          <AccionaButton
            id="errorBtn"
            onClick={() => {
              navigate('/app/projects' + +pidstring);
            }}
            classIcon="icon fas fa-times"
            msg={intl.formatMessage({ id: 'button.create.end' })}
          />
        </div>,
      ]}
    />
  );
};

ErrorPage.propTypes = {
  errorMessages: PropTypes.shape({
    errorType: PropTypes.string,
    status: PropTypes.number,
  }),
};

ErrorPage.defaultProps = {
  errorMessages: {},
};

export default ErrorPage;
